export default __webpack_public_path__ + "static/media/popup_m.508d3421.jpg";